import { Box, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { AsyncButton, EditableSectionRow, Indicator } from '@uplift/ui-v2';

import { useSettingsStyles } from '../../../../settings/styles';

export type AutopayModuleProps = {
  isMobile?: boolean;
  isAutopayOn: boolean;
  onClick?: () => Promise<void>;
};

export const AutopayModule: React.FC<AutopayModuleProps> = ({ isMobile, isAutopayOn, onClick }) => {
  const { classes } = useSettingsStyles();
  const l10n = useL10n();

  return (
    <Box display="flex" flexGrow={1} position="relative">
      <Box display="flex" flexDirection="column">
        <EditableSectionRow
          rowKey="autopay"
          label={l10n.accountSettings.billing.autopay}
          kind="custom"
        >
          <Box display="flex" flexDirection="column">
            <Box display="flex" gap="8px" alignItems="center">
              <Indicator color={isAutopayOn ? 'success' : 'grey'} size="ml" />
              <Typography variant="body1" className={classes.semiBold}>
                {isAutopayOn ? l10n.general.on : l10n.general.off}
              </Typography>
            </Box>
            <Box mt={1} />
            <Box display="flex" gap="16px" alignItems="center" pr={isMobile ? 2 : 12}>
              <Typography variant="body2" component="span">
                {isAutopayOn ? l10n.accountSettings.billing.afterSessionChargeDescription: l10n.accountSettings.billing.autopayEnsuresPeaceOfMind}
              </Typography>
            </Box>
          </Box>
        </EditableSectionRow>
      </Box>
      <Box display="flex" position="absolute" right="1rem" top="1rem">
        <AsyncButton
          color="secondary"
          size="small"
          variant={isAutopayOn ? 'text' : 'contained'}
          component="span"
          onClick={onClick}
        >
          {isAutopayOn ? l10n.accountSettings.billing.turnOff : l10n.accountSettings.billing.turnOn}
        </AsyncButton>
      </Box>
    </Box>
  );
};
